import { render } from "./Notepad.vue?vue&type=template&id=b6586d9a&scoped=true&bindings={}"
import script from "./Notepad.vue?vue&type=script&lang=ts"
export * from "./Notepad.vue?vue&type=script&lang=ts"

import "./Notepad.vue?vue&type=style&index=0&id=b6586d9a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b6586d9a"

export default script